

import VideoPlayer from "./videoplayer";

class VideoPlayerView extends VideoPlayer
{


    constructor (props)
    {
        super(props);

    
    }


    // *******************************************
    // functions pures
    // *******************************************
    childDrawVideoToCanvas(timecode)
    {
    }
    childRedrawCurrentFrame(timecode)
    {
    }
}

export default VideoPlayerView